import { ApiAction, ApiActionName } from "./ApiAction";
import { AutocompleteSuggestions } from "./../../types/Autocomplete";

export interface GetAutocompleteSuggestionsResponse extends AutocompleteSuggestions {}

export function getAutocompleteSuggestions(): ApiAction {
  return {
    method: "get",
    name: ApiActionName.GetAutocompleteSuggestions,
    url: `${process.env.REACT_APP_AUTOCOMPLETE_SUGGESTIONS_API_URL}`,
  };
}
